import api from '@cannect/services/api'
import { TGetBaseRecipeResponse, TValidateRecipeAccessRequest, TValidateRecipeAccessSuccess } from './types'

export const getBaseRecipe = (token: string) =>
  api.get<TGetBaseRecipeResponse>(`baserecipe/${token}`).then((res) => res.data)

export const validateRecipeAccess = (token: string, payload: TValidateRecipeAccessRequest) =>
  api.post<TValidateRecipeAccessSuccess>(`baserecipe/${token}/validate`, payload).then((res) => res.data)
